import { getAllOrderlist, getSlotStatusCount } from "../../config/Services";
import { getSlotIds, updateSlotCounts } from "./odsSlotService";
import { getOrderPollingPayload } from "./orderPollingPayloadConfig";

let subscribers = new Set();
let latestData = null;

let requestCounter = 0;
let latestRequestId = 0;

let selectedPollingDate = null;

export const setPollingDate = (date) => {
  selectedPollingDate = date;
};

const getPollingPayload = async () => {
  return await getOrderPollingPayload(selectedPollingDate);
};

const notifySubscribers = (payload) => {
  subscribers?.forEach((cb) => cb(payload));
};

export const subscribeOrderUpdates = (callback) => {
  subscribers?.add(callback);

  if (latestData) {
    callback(latestData);
  }

  return () => {
    subscribers?.delete(callback);
  };
};

export const fetchAllOrdersAndSlots = async () => {
  const payload = await getPollingPayload();
  if (!payload) return;

  const currentRequestId = ++requestCounter;
  latestRequestId = currentRequestId;

  getAllOrderlist(payload)
    .then((res) => {
      if (currentRequestId != latestRequestId) return;

      const data = res?.data?.data;

      const slotIds = getSlotIds();

      if (slotIds?.length) {
        getSlotStatusCount({
          orgId: localStorage.getItem("orgId"),
          locationId: localStorage.getItem("locId"),
          slotId: slotIds,
          fulfilmentStatus: [
            "CREATED",
            "ACCEPTED",
            "PREPARING",
            "PACKAGED",
            "IN_TRANSIT",
            "DELIVERED",
          ],
        })
          .then((countRes) => {
            const countData = countRes?.data?.data || [];
            updateSlotCounts(countData);
          })
          .catch(() => {});
      }

      const hasCreatedOrders = data?.orderResponseList?.some(
        (item) => item?.baseOrderResponse?.fulfilmentStatus === "CREATED"
      );

      const response = {
        data,
        hasNewOrder: false,
        hasCreatedOrders,
      };

      latestData = response;
      notifySubscribers(response);
    })
    .catch(() => {});
};

export const manualOrderRefresh = () => {
  fetchAllOrdersAndSlots();
};
